import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

import * as Services from '@shared/core/services';
import * as Tokens from '@shared/core/tokens';
import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';
import { Observable } from 'rxjs';

@Component({
    selector: 'shared-form-for-link-account-rewards',
    templateUrl: './form-for-link-account-rewards.shared.component.html',
    styleUrls: ['./form-for-link-account-rewards.shared.component.scss']
})
export class FormForLinkAccountRewardsComponent extends FormTypesComponent implements OnInit, OnDestroy {
    public error$: Observable<{ [key: string]: string; }>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
        public membersService: Services.MembersService,
    ) {
        super(config, formBuilder);
        this.formName = 'link-account-rewards';
    }

    ngOnInit(): void {
        this.loading$ = this.controllers.members.memberLinkRewardsAccountVerifyStatus$();
        this.error$ = this.controllers.members.linkAccountRewardsError$();
        this.formControl = this.formBuilder.group({
            memberCardNumber: [
                {
                    value: '',
                    disabled: false,
                },
                {
                    validators: Validators.compose([
                        Validators.required,
                        Validators.minLength(this.minLength),
                        Validators.maxLength(this.maxLength),
                    ]),
                }
            ],
            email: [
                { value: '', disabled: false },
                {
                    validators: Validators.compose([
                        Validators.required,
                        Validators.email
                    ]),
                    // asyncValidators: Validators.composeAsync([
                    //     CustomValidators.accountNumberWithEmailValidator(this.membersService, 'accountNumber')
                    // ])
                }
            ],
        });

        // this.formChangesListener$ = this.formControl.get('accountNumber').valueChanges
        //     .subscribe(value => {
        //         const a = this.formControl.get('accountNumber');
        //         if (a.invalid) return;

        //         const e = this.formControl.get('email');

        //         const isEmailFormatValid: boolean = e.errors?.email !== true && e.dirty && e.value !== '';
        //         if (isEmailFormatValid) {
        //             e.updateValueAndValidity({ onlySelf: true });
        //         }
        //     });
    }

    ngOnDestroy(): void {
        if (this.formChangesListener$ && !this.formChangesListener$.closed) this.formChangesListener$.unsubscribe();
    }

    public get minLength(): number {
        return this.config.memberCard && this.config.memberCard.minLength || 10;
    }

    public get maxLength(): number {
        return this.config.memberCard && this.config.memberCard.maxLength || 10;
    }

    public handleFormSubmit($event: Event): void {
        const formValues = this.getFormValues();
        this.controllers.members.verifyLinkRewardsAccount(formValues.memberCardNumber, formValues.email);
    }

    public handleSkipClick($event: Event): void {
        this.controllers.members.setSignUpStep();
    }

    public handleErrorButtonClick($event: Event): void {
        console.log('HANDLING BUTTON CLICK', $event, ($event.currentTarget as HTMLButtonElement).innerText);
    }
}
